
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]",
      function () {
        return require("private-next-pages/[lang]/index.tsx");
      }
    ]);
  